import axios from "axios";
import { getSkinTypeValue } from "../data/skin-types";

export const handleSubmit = async (question: string, skinType: string, sensitive: boolean | null, season: string) => {
  let skinTypeFilter = 'the skin type of the user is ' + getSkinTypeValue(skinType);

  let sensitiveFilter = '';
  if (sensitive !== null && sensitive) {
    sensitiveFilter = 'the user has a sensitive skin'
  }

  let filters = skinTypeFilter;
  if (sensitiveFilter !== '') {
    filters = filters + ', ' + sensitiveFilter
  }

  if (season !== "") {
    const seasonFilter = "the current season at the user's location is " + season.toLowerCase();
    filters = filters + ", " + seasonFilter + ".";
  }
  
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  };
  const data = {
    "question": question,
    "filters": filters
  };
  return await axios
    .post("https://d3gxwcejzov6bu.cloudfront.net/", data, {
      headers
    })
    .catch((e) => console.log(e));
}
